// extracted by mini-css-extract-plugin
export default {"iconTextButton":"IconTextButton_iconTextButton__1I7Ip","icon":"IconTextButton_icon__v7odS","text":"IconTextButton_text__YyIMz","disabled":"IconTextButton_disabled__zr1pJ"};